// @ts-nocheck
import React from 'react';

const SvgColorPalette = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M32.01 8.02c13.255 0 24 10.746 24 24 0 6.618-5.979 11-13 11h-5c-1.768 0-4 .324-4 3 0 2.628 2 4.28 2 7 0 1.617-1.272 3-4 3-13.254 0-24-10.744-24-24 0-13.254 10.746-24 24-24zm13.5 27a4.5 4.5 0 1 0-4.5-4.5 4.5 4.5 0 0 0 4.5 4.5zm-6.999-11a4.5 4.5 0 1 0-4.5-4.5 4.5 4.5 0 0 0 4.5 4.5zm-13 0a4.5 4.5 0 1 0-4.5-4.5 4.5 4.5 0 0 0 4.5 4.5zm-11.5 6.5a4.5 4.5 0 1 0 4.5-4.5 4.5 4.5 0 0 0-4.501 4.5z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgColorPalette;
